module.exports = __webpack_public_path__ + "media/3600_CT_2022_Two-Factor_Authentication_Attack.ff710404.mp4";